import { useGetMe } from '../api/generated/endpoints/me/me'
import { useSession } from './auth'

/**
 * Whether the signed-in person may administer the facility.
 *
 * Comes from `GET /api/me`, and it has to: admin status is NOT a claim in the
 * Supabase token. The backend derives it from the verified email against the
 * `admins` table and ADMIN_EMAILS, so the frontend has no way to work it out
 * and no business trusting a claim if there were one.
 *
 * `enabled` matters — without it every signed-out visitor to the landing page
 * fires a 401 at /api/me. `staleTime: Infinity` because the answer only changes
 * when somebody edits the admins table, and re-asking on each navigation would
 * put a spinner in front of the coach for nothing.
 */
export const ADMIN_ME_OPTIONS = {
  query: { staleTime: Infinity, gcTime: Infinity, retry: 1 },
} as const

export function useIsAdmin(): boolean {
  const session = useSession()
  const me = useGetMe({
    query: { enabled: Boolean(session), staleTime: Infinity, retry: false },
  })
  return me.data?.is_admin === true
}
